export default {"src":"/_next/static/media/invoice.84e65dc7.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};